import { Card, CardContent } from '@mui/material';

/**
 *
 * @param {string} field      - Title of the card
 * @param {string} value      - Card content
 * @param {string} className  - classNames for styling
 *
 * @returns {JSX.Element} 		- The TextDisplay component
 */
export default function TextDisplay({ field = '', value = '', className = '' }) {
  return (
    <Card className={className}>
      <CardContent>
        <div className=" font-medium">{field}:</div>
        <div className={value ? 'ml-2' : 'ml-2 text-gray-400'}>
          {value ? value : `Not Provided`}
        </div>
      </CardContent>
    </Card>
  );
}
